import React from 'react';
import { ClipboardList } from 'lucide-react';
import { COLORS, RADIUS, TYPOGRAPHY } from './design-tokens';

const ObservationCard = ({ observations }) => {
  const items = observations && observations.length > 0 ? observations : ['', '', ''];
  return (
    <div
      style={{
        background: COLORS.card,
        border: `1px solid ${COLORS.line}`,
        borderRadius: RADIUS.card,
        padding: '10px',
        marginTop: '6mm',
        pageBreakInside: 'avoid',
        breakInside: 'avoid'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px' }}>
        <ClipboardList size={16} color={COLORS.primary} strokeWidth={2.5} />
        <span style={{ ...TYPOGRAPHY.sectionTitle, color: COLORS.textPrimary, letterSpacing: '1px' }}>
          CONSIDERAÇÕES FINAIS
        </span>
      </div>
      {items.map((obs, i) => (
        <div
          key={i}
          style={{
            display: 'grid',
            gridTemplateColumns: '8px 1fr',
            alignItems: 'center',
            gap: '6px',
            marginBottom: i === items.length - 1 ? 0 : '6px'
          }}
        >
          <span style={{ color: COLORS.primary, fontSize: '14px', lineHeight: 1 }}>•</span>
          <div
            style={{
              borderBottom: `1px solid ${COLORS.line}`,
              fontSize: '11px',
              color: COLORS.textPrimary,
              paddingBottom: '3px',
              minHeight: '16px'
            }}
          >
            {obs}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ObservationCard;
